import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

// import Push from 'appcenter-push';
// import AppCenter from 'appcenter';

import constants from "../constants"
import API from '../API'
import { connect } from "react-redux"

class News extends Component {
  constructor(props) {
    super(props);

    this.newsHtml = null;

    /* fetch news page from wordpress */
    API.instance.fetchFromApi(constants.URL.newsUrl)
      .then((response) => {
        if (!response) throw new Error("no data");
        return response.text()
      })
      .then(text => {
        this.newsHtml = text;
        this.forceUpdate();
      }).catch(error => {
        console.error(error)
      });
  }



  render() {

    return (
      <div className="flex-container">
        <div id="news" dangerouslySetInnerHTML={{ __html: this.newsHtml }}></div>
      </div>
    );
  }
}

export default withRouter(connect()(News));